import { denormalize } from 'normalizr';

import * as schemas from 'schemas';

export const getReferralCoupon = state =>
  denormalize(state.referralCoupon.id, schemas.referralCoupon, state.entities);



// WEBPACK FOOTER //
// ./src/store/referralCoupon/selectors.js